module.exports = __webpack_public_path__ + "87fe72689229b2ca6400943acccfaf1d.png";